import Notice from './src/index.vue';

export { Notice };
export * from './src/type';
export * from './src/config';
